<template>
  <div>
    <el-row class="app-menu">
            <el-col class="app-menu-content">
              <!-- <el-popover
                placement="right"
                width="100"
                trigger="hover">
              <el-col class="qqpop">
                <el-row class="qqpop-item">
                  <div class="">会员联系群：</div>
                  <div>1036764247</div>
                </el-row>
                <el-row class="qqpop-item mt-10">
                  <div>培训交流工作群：</div>
                  <div>849741486</div>
                </el-row>
                <el-row class="qqpop-item mt-10">
                  <div>单位资信管理群：</div>
                  <div>124642187</div>
                </el-row>
                <el-row class="qqpop-item mt-10">
                  <div>咨询师登记管理群：</div>
                  <div>144481040</div>
                </el-row>
              </el-col>
                <a  slot="reference">
                  <div class="item1 item3">
                    <img class="qq" src="../../assets/images/qq_empty.png" alt="">
                  </div>
                </a>        
              </el-popover> -->
              <el-popover
                placement="right"
                width="100"
                trigger="hover"> 
                <div class="xiaoxi">
                  <div>工程咨询单位资信评价基本业务流程指引</div>
                  <img @click="openNewHref" src="../../assets/images/jiantou_xy.png" alt="">
                </div>   
                <a ref="#" slot="reference">
                  <div>
                    <div class="item1 item2"> 乙级<br>资信</div>  
                  </div>
                </a>         
              </el-popover>
              <el-popover
                placement="right"
                width="100"
                trigger="hover"> 
                <div class="erwei"><img class="erweima" src="../../assets/images/erweima.jpg"></div>
                <a  slot="reference">
                  <div class="item1">
                     <img class="weixin" src="../../assets/images/weixin1.png">
                  </div>
                </a>
              </el-popover>
              <el-popover
                placement="right"
                width="100"
                trigger="hover"> 
                <div class="lxpop">
                    <img class="imgs" src="../../assets/images/dianhua.png" alt="">
                    <div>免费咨询电话</div> 
                    <div class="lx-text">021-54663100</div>
                    <div class="lx-text">021-54663096</div>
                </div>
                <a ref="#" slot="reference">
                  <div>
                    <div class="item1 item2"> 联系<br>我们</div>  
                  </div>
                </a>         
              </el-popover>
              <el-popover
                placement="right"
                width="100"
                trigger="hover"> 
                <div class="erwei"><img class="erweima" src="../../assets/images/erweima.jpg"></div>
                <a  slot="reference">
                  <div class="item1">
                     <img class="weixin" src="../../assets/images/weixin1.png">
                  </div>
                </a>
              </el-popover>
              <el-popover
                placement="right"
                width="100"
                trigger="hover"> 
                <div class="xiaoxi">
                  <img src="../../assets/images/xiaoxi.png" alt="">
                  <div>如对网站和协会工作有任何建议，请在此留言</div>
                  <img src="../../assets/images/jiantou_xy.png" alt="">
                </div>              
                <a slot="reference"  @click="(dialogVisible=true)">
                  <div class="item1">
                    <img class="message" src="../../assets/images/liuyanban.png" alt="">
                  </div>
                </a>
              </el-popover>
                <el-backtop :visibility-height="-10" class="gotop" :right="0" :bottom="145">
                  <div class="item4">
                    <img class="jiantou" src="../../assets/images/jiantoushang.png" alt="">
                  </div>
                </el-backtop>         
            </el-col>  
        </el-row> 
        <el-dialog
          title="欢迎提出建议和意见"
          :visible.sync="dialogVisible"
          width="30%"
          :before-close="handleClose">
          <div>
            <el-form ref="ruleForm" label-width="100px" class="demo-ruleForm">
              <el-form-item label="留言内容:" prop="phone">
                <el-input type="textarea" :row="3" class='inputs'></el-input>
              </el-form-item>
              <el-form-item label="联系电话:" prop="phone">
                <el-input type="text" class='inputs'></el-input>
              </el-form-item>
              <el-form-item label="邮箱:" prop="email">
                <el-input type="text" class='inputs'></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" class='inputs pri' @click="(dialogVisible=false)">提交</el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-dialog>
  </div>     
</template>
<script> 
  export default {
    data(){
      return{
        dialogVisible:false
      }    
    },
    methods: {   
      handleClose() {
        this.dialogVisible=false      
      },
      openNewHref() {
        this.$router.push({
          path: '/DetailsPage',
          query: {
              docId: '5534fad4e5a84246ae3292f5b1077b4d'
          }
        }, () => {})
      }  
    }
  }
</script>
<style lang="scss" scoped>
  @import './Menu.scss';

</style>
